import { Fragment } from "react";

// Componenets
import InfoHeader from "components/atoms/InfoHeader";

// Constants
import { GAMBLE_LIST, SECOND_GAMBLE_LIST } from "constants/info";

// Hooks
import useTranslate from "hooks/useTranslate";

import "./styles.sass";
import { useBreakpoint } from "hooks/useBreakpoint";

const GambleInfo = () => {
  const t = useTranslate();
  const { isDesktop } = useBreakpoint();
  const { VITE_APP_PROJECT_NAME } = import.meta.env;

  return (
    <div className="GambleInfo">
      {isDesktop ? (
        <InfoHeader title="info.navigation.responsiblegame" />
      ) : (
        <>
          <InfoHeader title="footer.information" />
          <span className="GambleInfo__secondTitle">
            {t("info.navigation.responsiblegame").toUpperCase()}
          </span>
        </>
      )}
      {GAMBLE_LIST(VITE_APP_PROJECT_NAME).map((item) => (
        <Fragment key={item.id}>
          {item.header && <p className="GambleInfo__title">{t(item.header)}</p>}
          {item.title && (
            <p className="GambleInfo__sub-title">{t(item.title)}</p>
          )}
          <span className="GambleInfo__description">{t(item.description)}</span>
        </Fragment>
      ))}
      <div>
        <a
          className="GambleInfo__link"
          href="https://www.begambleaware.org/gambling-problems/do-i-have-a-gambling-problem/"
        >
          {t("gamble.link.problem")}
        </a>
      </div>
      <br />
      <p className="GambleInfo__description">
        {t("gamble.information.description.2")}
      </p>
      <a
        className="GambleInfo__link"
        href="https://www.begambleaware.org/safer-gambling/"
      >
        {" "}
        {t("gamble.link.safer")}
      </a>
      {SECOND_GAMBLE_LIST(VITE_APP_PROJECT_NAME).map((item) => (
        <Fragment key={item.id}>
          {item.header && (
            <p className="GambleInfo__header">{t(item.header)}</p>
          )}
          {item.title && <p className="GambleInfo__title">{t(item.title)}</p>}
          <p className="GambleInfo__description">{t(item.description)}</p>
        </Fragment>
      ))}
      <a
        className="GambleInfo__link"
        href="https://famisafe.wondershare.com/internet-filter/best-internet-filters.html"
      >
        {t("gamble.link.internet")}
      </a>
      <p className="GambleInfo__title">{t("gamble.exclusion.title")}</p>
      <p className="GambleInfo__description">
        {t(`gamble.exclusion.description.${VITE_APP_PROJECT_NAME}`)}
      </p>
    </div>
  );
};

export default GambleInfo;
